import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './Label.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const cln = classnames.bind(styles);
function Label({
  children = '',
  className,
  ...rest
}) {
  const classes = cln('Label', className);
  return /*#__PURE__*/_jsx("span", {
    className: classes,
    ...rest,
    children: children
  });
}
Label.propTypes = {
  /** Text or node */
  children: PropTypes.node,
  /** custom class name */
  className: PropTypes.string,
  /** Click event handler */
  onClick: PropTypes.func
};
export default Label;